import ko from 'knockout'

 var globals = {};
 globals.regions = ['At-Sea','AWCA','AEB','LPB','BBB','DCA','KIB','RAK','WOC','RUS'];
 globals.regionsFlt = [{region:'All'}, {region:'At-Sea'},{region:'AWCA'},{region:'AEB'},{region:'LPB'},{region:'BBB'},{region:'DCA'},{region:'KIB'},{region:'RAK'},{region:'WOC'},{region:'RUS'}];
 globals.va_sectors = ['LAB FISH','LAB OTHER','PROPR FISH','PROPR OTHER','OPI','INDT','TOTAL VALUE ADDED'];
 globals.hi_sectors = ['LOW_HH','MED_HH','HI_HH','TOTAL HOUSEHOLD INCOME'];
 globals.gov_sectors = ['SLGOVT'];
 globals.a1_sectors = ['ANR-A','CONSTR-A','UTILITIES-A','OTHFOOD-A','OTHMANU-A','TRANSP-A','WHOLESALE-A','RETAIL-A','SERVICES-A','MISC-A','SLGOVTIND-A','FGOVTIND-A','NON-SEAFOOD TOTAL'];
 globals.gdpDeflator = [
     { year:"2014", deflator: 1.00000000},
     { year:"2015", deflator: 1.009513439},
     { year:"2016", deflator: 1.020109351},
     { year:"2017", deflator: 1.039287613},
     { year:"2018", deflator: 1.064240541},
     { year:"2019", deflator: 1.083234204},
     { year:"Custom", deflator: 0}   
     ];
 globals.reportNames = [{ rptName : 'Table A Baseline Data' },
                        { rptName : 'Table B Economic Impacts (quantity change)' },
                        { rptName : 'Table C Economic Impacts (% change)' },
                        // { rptName : 'Table A Baseline Data' },
                        // { rptName : 'Table B   Economic impacts (quantity change)' },
                        // { rptName : 'Table C   Economic impacts (percentage change)' },
                        // { rptName : 'Table A Baseline Data' },
                        // { rptName : 'Table B   Economic impacts (quantity change)' },
                        // { rptName : 'Table C   Economic impacts (percentage change)' },
                        { rptName : 'Table A.1 Baseline Non-seafood Industry Output ($ million)' },
                        { rptName : 'Table B.1 Economic Impacts on Non-seafood Industry Output ($ million, quantity change)' },
                        { rptName : 'Table C.1 Economic Impacts on Non-seafood Industry Output (% change)' },
                        { rptName : 'Table A.2 Baseline Non-seafood Industry Employment (# of jobs)' },
                        { rptName : 'Table B.2 Economic Impacts on Non-seafood Industry Employment (change in # jobs)' },
                        { rptName : 'Table C.2 Economic Impacts on Non-seafood Industry Employment (% change)' }];

    globals.prep_shock = function(shock_vector, table_b, mrsam) {
        mrsam.vec.forEach(element => {
            shock_vector[element.split(".")[0]]={};
            //self.table_b.ind[element.split(".")[0]]={};
        });
        
        mrsam.vec.forEach(element => {
            shock_vector[element.split(".")[0]][element.split('.')[1]]=ko.observable(0).extend({ numeric: true});
            table_b.ind[element.split(".")[0]][element.split('.')[1]]=ko.observable(0);
        });
    };
            
    globals.map_shock_vector = function(shock_vector) {
        return shock_vector;    
    };

 export default globals;